import {
  ADD_SALARY_FAILURE,
  ADD_SALARY_REQUEST,
  ADD_SALARY_SUCCESS,
  GET_FILTERED_SALARIES_FAILURE,
  GET_FILTERED_SALARIES_REQUEST,
  GET_FILTERED_SALARIES_SUCCESS,
} from "./ActionType";

const initialState = {
  salaryList: {},
  salaryAdded: {},
  loading: false,
  error: null,
};

export const salaryReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_SALARY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ADD_SALARY_SUCCESS:
      return {
        ...state,
        salaryAdded: action.payload,
        loading: false,
        error: null,
      };
    case ADD_SALARY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "RESET_SALARY":
      return {
        ...state,
        salaryAdded: {},
        error: null,
      };
    case GET_FILTERED_SALARIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_FILTERED_SALARIES_SUCCESS:
      return {
        ...state,
        salaryList: action.payload,
        loading: false,
        error: null,
      };
    case GET_FILTERED_SALARIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
